import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {Avatar, OrderSteps, PaymentTypes} from 'components/common/app';
import {Fab, Dialog, Input, Button, Loading} from 'components/common/uiKit';

import {OrderApi} from 'services/network/api';
import {serverUrl} from 'services/network';
import * as RouteService from 'services/route';

class Bills extends React.Component {
    constructor(props) {
        super(props);

        const qs = RouteService.QueryStringService.getQyeryStrings();

        this.state = {
            data: [],
            showFilterDialog: false,
            loading: true,
            filter: {
                username: qs && qs.username || '',
                fullName: qs && qs.fullName || '',
                courseName: qs && qs.courseName || '',
                step: qs && (qs.step || qs.step == 0) ? parseInt(qs.step) : 4,
                payment: qs && (qs.payment || qs.payment == 0) ? parseInt(qs.payment) : 1
            },
            tempFilter: {}
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const {filter} = this.state;

        this.setState({loading: true});
        OrderApi.GetBills(filter)
            .then(res => {
                if (res && res.status == 200) {
                    const {data} = res;
                    this.setState({data});
                }
            }).finally(x => {
            this.setState({loading: false});
        });
    }

    handleStep = (type) => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill.Steps;

        switch (type) {
            case 'PaymentProgress':
                return {
                    icon: '',
                    title: pageTranslates[type],
                    background: ' bg-dark opacity-50'
                };
            case 'SucceedPayment':
                return {
                    icon: <i className="fa fa-check color-green1-dark fa-3x float-left ml-3 mt-3"></i>,
                    title: pageTranslates[type],
                    background: ' bg-success opacity-50'
                };
            case 'UnSucceedPayment':
                return {
                    icon: <i className="fa fa-times color-red1-dark fa-3x float-left ml-3 mt-3"></i>,
                    title: pageTranslates[type],
                    background: ' bg-danger opacity-50'
                };
            case 'Pending':
                return {
                    icon: <i className="fa fa-spinner text-danger fa-3x float-left ml-3 mt-3"></i>,
                    title: pageTranslates[type],
                    background: ' bg-warning opacity-50'
                };
            case 'NotApproved':
                return {
                    icon: <i className="fa fa-ban color-red1-dark fa-3x float-left ml-3 mt-3"></i>,
                    title: pageTranslates[type],
                    background: ' bg-danger opacity-50'
                };
        }
    };

    renderItem = ({id, courseName, courseImage, username, userFullName, userImage, price, step, stepTitle, paymentType, paymentTypeTitle, createdDate, modifiedDate}) => {

        const stepRes = this.handleStep(stepTitle);
        const courseImageUrl = `${serverUrl}${courseImage.split('\\').join('/')}`;
        const userImageUrl = userImage ? `${serverUrl}${userImage.split('\\').join('/')}` : '';

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill;

        return (
            <div className="card card-style" style={{height: 250, backgroundImage: `url(${courseImageUrl})`}}
                 onClick={() => this.props.history.push({pathname: `/app/admin/billDetail?id=${id}`})}>
                <div className="card-top">
                    {stepRes.icon}
                    <div className='float-right mr-2 mt-2'>
                        <Avatar src={userImageUrl}/>
                        <p className='text-white mt-1 mb-0'>{username}</p>
                        <p className='text-white mt-0'>{userFullName}</p>
                    </div>
                </div>
                <div className="card-bottom">
                    <div className="float-right mr-3">
                        <h1 className="color-white font-700 text-right mb-n1">{courseName}</h1>
                        <p className="color-white text-right opacity-80 mt-2 mb-2">{`${price.toLocaleString()} ${pageTranslates.Currency} | ${pageTranslates.Steps[stepTitle]} | ${pageTranslates.PaymentTypes[paymentTypeTitle]}`}</p>
                    </div>
                </div>
                <div className={`card-overlay ${stepRes.background}`}></div>
            </div>
        );
    };

    filterDialogFooter = () => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill.Main;

        return (
            <div className='flex-fill d-flex justify-content-around'>
                <Button type='primary' onClick={this.applyFilter}>
                    {pageTranslates.Submit}
                </Button>
                <Button type='secondary' onClick={() => this.setState({showFilterDialog: false})}>
                    {pageTranslates.Cancel}
                </Button>
            </div>
        );
    };

    onStepChange = event => {
        let {tempFilter} = this.state;
        const step = event.target.value;
        tempFilter.step = parseInt(step);
        this.setState({tempFilter});
    };

    onPaymentChange = event => {
        let {tempFilter} = this.state;
        const payment = event.target.value;
        tempFilter.payment = parseInt(payment);
        this.setState({tempFilter});
    };

    inputChange = name => event => {
        let {tempFilter} = this.state;
        const value = event.target.value;
        tempFilter[name] = value;
        this.setState({tempFilter});
    };

    showFilter = () => {
        const {filter} = this.state;
        this.setState({showFilterDialog: true, tempFilter: filter});
    };

    applyFilter = () => {
        const {tempFilter} = this.state;
        const {history} = this.props;
        history.replace({
            pathname: '/app/admin/bills?' + new URLSearchParams(tempFilter).toString(),
        });
        //this.setState({filter: tempFilter, showFilterDialog: false}, () => this.loadData());
    };

    render() {
        const {loading} = this.state;
        if (loading)
            return <Loading/>;

        const {data, showFilterDialog, tempFilter} = this.state;
        const count = data.length;
        const {username, fullName, courseName, step, payment} = tempFilter;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill.Main;

        return (
            <div>
                {data && data.map(items => this.renderItem(items))}

                <Fab color="secondary" size="small" icon="filter" badgeValue={count} badgeColor='primary'
                     onClick={this.showFilter}/>

                <Dialog open={showFilterDialog} title={pageTranslates.Filter} width='xl' footer={this.filterDialogFooter()}>
                    <div>
                        <div>
                            <label className='mb-0 color-primary'>{pageTranslates.Username}</label>
                            <Input placeholder={pageTranslates.Username} value={username} onChange={this.inputChange('username')}/>
                        </div>
                        <div>
                            <label className='mb-0 color-primary'>{pageTranslates.UserFullName}</label>
                            <Input placeholder={pageTranslates.UserFullName} value={fullName} onChange={this.inputChange('fullName')}/>
                        </div>
                        <div>
                            <label className='mb-0 color-primary'>{pageTranslates.CourseName}</label>
                            <Input placeholder={pageTranslates.CourseName} value={courseName} onChange={this.inputChange('courseName')}/>
                        </div>
                        <div>
                            <label className='mb-0 color-primary'>{pageTranslates.Step}</label>
                            <OrderSteps value={step} onChange={this.onStepChange}/>
                        </div>
                        <div>
                            <label className='mb-0 color-primary'>{pageTranslates.PaymentType}</label>
                            <PaymentTypes value={payment} onChange={this.onPaymentChange}/>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Bills));